//
//
//
//
//
//
//
//
//
//
//
//
//

import { focus } from '~/helpers/directives';

export default {
  name: 'SfChevron',
  directives: {
    focus,
  },
};
